<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage" id="titlepage">
<div class="ipadfp"><span aria-label="page iv" epub:type="pagebreak" id="page_iv" role="doc-pagebreak"><span aria-label="page v" epub:type="pagebreak" id="page_v" role="doc-pagebreak"><img alt="Make Russia Great Again, by Christopher Buckley, Simon &amp; Schuster" class="imagefp" src="e9781982157487/images/title.jpg"/></span></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?44c40df1